import { generateUUID, $ } from '../helper/utils';

export default (opener) => {
  const title = opener.getAttribute('data-title') || opener.textContent;
  const content = () => {
    const elementText = opener.getAttribute('data-text-element');
    if (elementText !== null) {
      const el = $(`${elementText} .text-box`);
      if (elementText !== null) {
        const html = el.innerHTML;
        el.textContent = '';
        return html;
      }

      return '';
    }

    return opener.getAttribute('data-text');
  };
  const id = generateUUID();
  const { body } = document;

  const aside = document.createElement('aside');
  aside.id = id;
  aside.className = 'modal-wrapper';
  aside.setAttribute('aria-hidden', true);

  const modalBox = document.createElement('div');
  modalBox.className = 'modal-box';

  const header = document.createElement('header');
  header.className = 'modal-header d-flex align-items-center justify-content-between';
  header.innerHTML = `<h4 class="modal-title v2 mb-0">${title[0].toUpperCase() + title.slice(1)}</h4><button class="close-btn close-modal icon-btn"><span class="close-btn-bar"></span><span class="close-btn-bar"></span></button>`;

  const modalInner = document.createElement('div');
  modalInner.className = 'modal-inner-content';
  modalInner.innerHTML = content();

  if (modalInner.innerHTML === '' || modalInner.innerHTML === null) {
    console.warn('No content for modal');
    return;
  }

  const video = modalInner.querySelector('video');
  const ytEmbed = modalInner.querySelector('iframe');

  modalBox.appendChild(header);
  modalBox.appendChild(modalInner);
  aside.appendChild(modalBox);
  body.appendChild(aside);

  opener.modal = {
    modal: null,
    open: false,
  };

  const activeClass = 'modal-active';
  const closeBtn = header.querySelector('.close-modal');

  const closeModal = function () {
    if (video !== null && video.paused === false) {
      video.pause();
    }

    if (ytEmbed !== null) {
      ytEmbed.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    }

    aside.setAttribute('aria-hidden', 'true');
    aside.classList.remove(activeClass);
    opener.modal.open = false;
    document.documentElement.classList.remove('noscroll');
  };

  // add click listener to close button
  closeBtn.addEventListener('click', closeModal, { passive: true });
  aside.addEventListener('click', (event) => {
    if (event.target === aside) {
      closeModal();
    }
  }, { passive: true });

  // eslint-disable-next-line
  return {
    show() {
      aside.classList.add(activeClass);
      aside.setAttribute('aria-hidden', 'false');
      opener.modal.open = true;
      document.documentElement.classList.add('noscroll');
    },
    close: closeModal,
  };
};
